import { render } from "./Ip.vue?vue&type=template&id=1f49a93e&scoped=true"
import script from "./Ip.vue?vue&type=script&lang=js"
export * from "./Ip.vue?vue&type=script&lang=js"

import "./Ip.vue?vue&type=style&index=0&id=1f49a93e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f49a93e"]])

export default __exports__